export const isTripAlreadyAlignedToCargoItem = (carryingCargo, tripId) => carryingCargo.list
    .find(aTrip => aTrip.id === tripId) ? true : false;

